import React from 'react';
import ReactDOM from 'react-dom/client';
//import './style.css';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
//import { initializeGTM } from './utils/gtm'; // Importa la inicialización de GTM

// Inicializar Google Tag Manager
//initializeGTM();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Para medir rendimiento en tu app
reportWebVitals();
